import * as React from 'react';
import { SortableTree } from '../SortableTree';

import { Wrapper } from './styles';

export const CompanySortableTree = ({
	data,
	onChange,
	searchQuery,
	onMenuOptionSelect,
	currencySymbol,
	hideTreeItemChart,
	canEdit,
	...props
}) => (
	<Wrapper>
		{!data ? (
			'Loading...'
		) : (
			<SortableTree
				{...props}
				data={data || []}
				dragDisabled={canEdit}
				currencySymbol={currencySymbol}
				onChange={onChange}
				searchQuery={searchQuery}
				onMenuOptionSelect={onMenuOptionSelect}
				hideTreeItemChart={hideTreeItemChart}
			/>
		)}
	</Wrapper>
);
